import ScrollToTop from 'ScrollToTop';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { SplitFactoryProvider } from '@splitsoftware/splitio-react';

import { sentryService } from '@/services/index';
import '@/styles/index.css';

import App from './app';
import { SPLIT_AUTHORIZATION_KEY, SPLIT_KEY } from './lib/config';

if (sentryService.isSentryServiceEnabled()) {
  sentryService.init();
}

// Ensure root element exists
const rootElement = document.getElementById('root');
if (!rootElement) {
  const error = new Error(
    "Root element not found. Ensure <div id='root'></div> exists in your index.html."
  );
  if (sentryService.isSentryServiceEnabled()) {
    sentryService.captureException(error);
  }
  throw error;
}

const splitConfig = {
  core: {
    authorizationKey: SPLIT_AUTHORIZATION_KEY,
    key: SPLIT_KEY,
  },
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <SplitFactoryProvider config={splitConfig}>
      <BrowserRouter>
        <App />
        <ScrollToTop />
      </BrowserRouter>
    </SplitFactoryProvider>
  </React.StrictMode>
);
